import React from "react";
import cl from "classnames";
import { Link } from "react-router-dom";

export default function DiscussionTab({ tab }) {
  return (
    <div
      className={cl("lesson_tab overflow-auto x-h-md-100", {
        active: tab === "discuss",
      })}
    >
      <div className="lesson_body">
        <ul className="lesson_breadcrumbs">
          <li className="lesson_breadcrumbs_item">
            <Link to="#">
              <span className="bi bi-house text-muted"></span>
            </Link>
          </li>
          <li className="lesson_breadcrumbs_item">
            <Link to="#">
              <span>Clojure</span>
            </Link>
          </li>
          <li className="lesson_breadcrumbs_item">
            <Link to="#">
              <span>Сокращенный синтаксис создания функции 10/43</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}
